module.exports = __webpack_public_path__ + "static/media/LearnershipUpload_Template.4a32c648.xlsx";